module.exports = __webpack_public_path__ + "01ac81f557c9fd262c94f040f82f3931.svg";